import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { withTranslation } from 'react-i18next';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
const RADIAN = Math.PI / 180;

class SimplePieChart extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      compliance: PropTypes.number.isRequired,
      partial: PropTypes.number.isRequired,
      NotCompliant: PropTypes.number.isRequired,
    })).isRequired,
  };

  renderCustomizedLabel = ({ cx, cy, midAngle, outerRadius, percent }) => {
    const radius = outerRadius * 0.5; // Adjusted for pie chart
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        fontSize="14"
        fontWeight="bold"
        stroke="none"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  render() {
    const { data } = this.props;
    //console.log(data);
    const chartData = [
      { name: 'Compliance', value: data[0]?.Compliance },
      { name: 'Partial', value: data[0]?.Partial },
      { name: 'Not Compliant', value: data[0]?.NotCompliant },
      { name: 'Null', value: data[0]?.Null },
    ];

    return (
      <ResponsiveContainer height={300} width="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={this.renderCustomizedLabel}
            outerRadius={90}
            innerRadius={0}  // Set innerRadius to 0 for a full pie chart
            dataKey="value"
            animationDuration={800}
            animationEasing="ease-out"
          >
            {
              chartData.map((entry, index) => (
                <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
              ))
            }
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #ddd',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            }}
            itemStyle={{ color: '#000' }}
          />
          <Legend
            layout="horizontal"
            align="center"
            verticalAlign="bottom"
            iconType="circle"
            wrapperStyle={{
              paddingTop: '20px',
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default SimplePieChart;
